import { render } from "./login.vue?vue&type=template&id=09dfdf6c&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=09dfdf6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dfdf6c"]])

export default __exports__